import { newDateFromUTC, newDateToUTC } from '@bc-library/common'
import { afterReceivingOne as afterReceivingOneResource } from '@/services/resource/hooks';

export const toValidDate = (value: unknown): Date | null => {
  if (value == null || value === '') return null
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value
  const date = new Date(value as string | number)
  return Number.isNaN(date.getTime()) ? null : date
}

export const normalizeEvaluationDates = (object: Record<string, any>) => {
  if (!object || typeof object !== 'object') return object

  // Business dates come as UTC midnight strings; a Date was already shifted by a previous pass (an evaluation
  // received by afterReceiving, then normalized again after an update): shifting it again moved it a day back.
  const fromUTCOnce = (value: unknown) => (value instanceof Date ? value : value ? newDateFromUTC(value as string) : null)
  object._created = toValidDate(object._created)
  object.startDate = fromUTCOnce(object.startDate)
  object.endDate = fromUTCOnce(object.endDate)
  object.trainingExecutionDate = fromUTCOnce(object.trainingExecutionDate)
  object.evaluationCompleted = toValidDate(object.evaluationCompleted)
  object.evaluationCompletedAfter = toValidDate(object.evaluationCompletedAfter)
  object.signatureDate = toValidDate(object.signatureDate)
  object.signatureDateAfter = toValidDate(object.signatureDateAfter)
  object.abandonAt = toValidDate(object.abandonAt)

  return object
}

// DATA RECEIVED FOM API (FROM UTC)

// ARRAYS
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){
    return normalizeEvaluationDates({
      ...object,
      projectId: object.projectId && {
          ...object.projectId,
          startDate: object.projectId.startDate && newDateFromUTC(object.projectId.startDate),
          endDate: object.projectId.endDate && newDateFromUTC(object.projectId.endDate),
      },
      resource: object.resource && afterReceivingOneResource(object.resource),
    })
  }
  return object;
}

// OBJECT FIELDS




// DATA TO BE SENT TO API (TO UTC)

// ARRAYS
export const beforeSending = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
      return beforeSendingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      startDate: object.startDate && newDateToUTC(object.startDate),
      endDate: object.endDate && newDateToUTC(object.endDate),
      trainingExecutionDate: object.trainingExecutionDate && newDateToUTC(object.trainingExecutionDate),
    }
  }
  return object;
}


// OBJECT FIELDS




